import type { Address, Guests, Property } from '../interfaces';

export function formatGuestAddress(guest: Guests) {
  const { line1, line2, city, state, zipCode, countryCode } = guest;

  const firstPart = [line1, line2, city, state]
    .filter((part) => typeof part === 'string' && part.trim() !== '')
    .join(' ');

  const secondPart = [zipCode, countryCode]
    .filter((part) => typeof part === 'string' && part.trim() !== '')
    .join(' ');

  const address =
    firstPart || secondPart
      ? [firstPart, secondPart].filter(Boolean).join(', ')
      : 'Not provided';

  return address;
}

export function formatCustomerAddress(customer?: Address) {
  if (!customer) return 'Not provided';
  const { Line1, Line2, City, PostalCode, CountrySubdivisionCode } = customer;

  const firstPart = [Line1, Line2, City]
    .filter((part) => typeof part === 'string' && part.trim() !== '')
    .join(' ');

  const secondPart = [PostalCode, CountrySubdivisionCode]
    .filter((part) => typeof part === 'string' && part.trim() !== '')
    .join(' ');

  const address =
    firstPart || secondPart
      ? [firstPart, secondPart].filter(Boolean).join(', ')
      : 'Not provided';

  return address;
}

export function formatPropertyAddress(property?: Property) {
  if (!property) return 'Not provided';
  const { streetName, streetNumber, city, zipCode, state } = property;

  const firstPart = [streetName, streetNumber, city]
    .filter((part) => typeof part === 'string' && part.trim() !== '')
    .join(' ');

  const secondPart = [zipCode, state]
    .filter((part) => typeof part === 'string' && part.trim() !== '')
    .join(' ');

  const address =
    firstPart || secondPart
      ? [firstPart, secondPart].filter(Boolean).join(', ')
      : 'Not provided';

  return address;
}

export function formatPropertyAddressPortal(property?: Property) {
  if (!property) return 'Not provided';
  const parts: string[] = [];

  const { streetName, streetNumber, city, zipCode, state } = property;

  if (streetName) {
    parts.push(`${streetNumber} ${streetName} ,`);
  }

  if (city || state) {
    parts.push(`${city ?? ''} ${state ?? ''}`.trim() + ',');
  }

  if (zipCode) {
    parts.push(zipCode);
  }

  return parts.join('\n');
}
